/**
 * Utility for playing notification sounds
 */

let isAudioEnabled = true;

/**
 * Play notification sound from file
 * Uses the notification.mp3 file from /public/sounds/
 */
export const playNotificationSound = () => {
  if (!isAudioEnabled) {
    return;
  }

  try {
    const audio = new Audio('/sounds/notification.mp3');
    audio.volume = 0.7; // 70% volume - adjust as needed

    audio.play()
      .catch(error => {
        // Handle autoplay restrictions - browsers may block autoplay
        // Error handled silently
      });
  } catch (error) {
    // Error handled silently
  }
};

/**
 * Enable or disable notification sounds
 * @param {boolean} enabled - Whether to enable or disable sounds
 */
export const setAudioEnabled = (enabled) => {
  isAudioEnabled = enabled;
  localStorage.setItem('alertSoundsEnabled', JSON.stringify(enabled));
};

/**
 * Check if audio is enabled
 * @returns {boolean} Whether audio notifications are enabled
 */
export const isAudioNotificationEnabled = () => {
  // Check localStorage on first access
  const stored = localStorage.getItem('alertSoundsEnabled');
  if (stored !== null) {
    isAudioEnabled = JSON.parse(stored);
  }
  return isAudioEnabled;
};

/**
 * Initialize audio settings from localStorage
 * Call this on app startup
 */
export const initializeAudioSettings = () => {
  const stored = localStorage.getItem('alertSoundsEnabled');
  if (stored !== null) {
    isAudioEnabled = JSON.parse(stored);
  }
};

export default {
  playNotificationSound,
  setAudioEnabled,
  isAudioNotificationEnabled,
  initializeAudioSettings,
};
